import FontPicker from 'react-fontpicker-ts'
import 'react-fontpicker-ts/dist/index.css'
import './font-input.scss'
const FontInput = ({ value, label, name, onChange }) => {
  function handleChange(newValue) {
    if (value !== newValue) {
      onChange(newValue)
    }
  }
  return (
    <div className="font-input">
      <label htmlFor={name}>{label}</label>
      <FontPicker defaultValue={value} value={handleChange} />
    </div>
  )
}

export default FontInput
